import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { RefreshCw, Download, CheckCircle, AlertCircle, Clock, Shield, Database, Bug, Server, Zap, FileText, Users } from 'lucide-react';

const UpdatesManager = () => {
  const [updating, setUpdating] = useState({});
  const [checkingUpdates, setCheckingUpdates] = useState(false);
  const [lastCheck, setLastCheck] = useState(null);
  const [updateStatus, setUpdateStatus] = useState({});
  const [bulkUpdating, setBulkUpdating] = useState({});
  const [bulkProgress, setBulkProgress] = useState({});
  const [updateOutput, setUpdateOutput] = useState({});

  const [updates, setUpdates] = useState({
    vulnerabilities: {
      title: "Vulnerability Databases & Feeds",
      icon: <Shield className="w-5 h-5 text-red-400" />,
      items: [
        { id: 'nvd_cve',          name: 'NVD CVE / Nuclei',       description: 'NIST CVE Database + templates Nuclei',            current: '-', latest: '-', status: 'unknown', size: '~200MB',  command: 'update_nvd_cve' },
        { id: 'cisa_kev',         name: 'CISA KEV',               description: 'Known Exploited Vulnerabilities Catalog',         current: '-', latest: '-', status: 'unknown', size: '~5MB',    command: 'update_cisa_kev' },
        { id: 'epss',             name: 'EPSS Scores',            description: 'Exploit Prediction Scoring System',               current: '-', latest: '-', status: 'unknown', size: '~50MB',   command: 'update_epss' },
        { id: 'openvas_feed',     name: 'OpenVAS NVT Feed',       description: 'Network Vulnerability Tests (OpenVAS)',           current: '-', latest: '-', status: 'unknown', size: '~500MB',  command: 'update_openvas_feed' },
        { id: 'metasploit_db',    name: 'Metasploit Modules',     description: 'Exploit & Auxiliary modules (git pull)',          current: '-', latest: '-', status: 'unknown', size: '~300MB',  command: 'update_metasploit' },
        { id: 'exploitdb',        name: 'Exploit-DB',             description: 'Public exploits database (SearchSploit)',         current: '-', latest: '-', status: 'unknown', size: '~1GB',    command: 'update_exploitdb' },
        { id: 'nuclei_templates', name: 'Nuclei Templates',       description: 'Vulnerability detection templates',           current: '-', latest: '-', status: 'unknown', size: '~200MB',  command: 'update_nuclei_templates' },
      ]
    },
    docker: {
      title: "Conteneurs Docker",
      icon: <Server className="w-5 h-5 text-blue-400" />,
      items: [
        { id: 'openvas',    name: 'OpenVAS',    description: 'Container Docker OpenVAS/GVM',       current: '-', latest: '-', status: 'unknown', size: '~3GB',   command: 'docker_pull_openvas' },
        { id: 'metasploit', name: 'Metasploit', description: 'Container Docker Metasploit',        current: '-', latest: '-', status: 'unknown', size: '~2GB',   command: 'docker_pull_metasploit' },
        { id: 'ollama',     name: 'Ollama',     description: 'Container Docker Ollama (LLM)',      current: '-', latest: '-', status: 'unknown', size: '~500MB', command: 'docker_pull_ollama' },
        { id: 'zap',        name: 'OWASP ZAP',  description: 'Container Docker OWASP ZAP',        current: '-', latest: '-', status: 'unknown', size: '~800MB', command: 'docker_pull_zap' },
      ]
    },
    llm: {
      title: "LLM Models",
      icon: <Zap className="w-5 h-5 text-purple-400" />,
      items: [
        { id: 'qwen',      name: 'Sylink2:27b',        description: 'Main SYLINK flagship model',  current: '-', latest: '-', status: 'unknown', size: '19GB',  command: 'ollama_pull_qwen' },
        { id: 'llama3',    name: 'Qwen3:8b',            description: 'Fast model',                     current: '-', latest: '-', status: 'unknown', size: '4.9GB', command: 'ollama_pull_llama3' },
        { id: 'deepseek',  name: 'DeepSeek R1:14b',     description: 'Advanced reasoning',               current: '-', latest: '-', status: 'unknown', size: '8.9GB', command: 'ollama_pull_deepseek' },
        { id: 'mistral',   name: 'Mistral:7b',           description: 'Lightweight multilingual model',          current: '-', latest: '-', status: 'unknown', size: '4.1GB', command: 'ollama_pull_mistral' },
        { id: 'deepcoder', name: 'DeepSeek Coder:6.7b', description: 'Specialized code generation',     current: '-', latest: '-', status: 'unknown', size: '3.8GB', command: 'ollama_pull_deepcoder' },
      ]
    },
    tools: {
      title: "Outils Pentest CLI",
      icon: <Bug className="w-5 h-5 text-yellow-400" />,
      items: [
        { id: 'nmap',        name: 'Nmap',         description: 'Network scanner',                       current: '-', latest: '-', status: 'unknown', size: '~10MB',  command: 'update_nmap' },
        { id: 'nikto',       name: 'Nikto',        description: 'Scanner web',                          current: '-', latest: '-', status: 'unknown', size: '~5MB',   command: 'update_nikto' },
        { id: 'sqlmap',      name: 'SQLMap',       description: 'SQL injection tool',                   current: '-', latest: '-', status: 'unknown', size: '~15MB',  command: 'update_sqlmap' },
        { id: 'hydra',       name: 'Hydra',        description: 'Brute-force multi-protocole',          current: '-', latest: '-', status: 'unknown', size: '~3MB',   command: 'update_hydra' },
        { id: 'wpscan',      name: 'WPScan',       description: 'Scanner WordPress',                    current: '-', latest: '-', status: 'unknown', size: '~50MB',  command: 'update_wpscan' },
        { id: 'masscan',     name: 'Masscan',      description: 'Scanner ports ultra-rapide',           current: '-', latest: '-', status: 'unknown', size: '~2MB',   command: 'update_masscan' },
        { id: 'rustscan',    name: 'RustScan',     description: 'Scanner ports rapide (Rust)',          current: '-', latest: '-', status: 'unknown', size: '~5MB',   command: 'update_rustscan' },
        { id: 'gobuster',    name: 'Gobuster',     description: 'Directory/DNS fuzzer',               current: '-', latest: '-', status: 'unknown', size: '~10MB',  command: 'update_gobuster' },
        { id: 'feroxbuster', name: 'Feroxbuster',  description: 'Fuzzer contenu web (Rust)',            current: '-', latest: '-', status: 'unknown', size: '~8MB',   command: 'update_feroxbuster' },
        { id: 'ffuf',        name: 'FFUF',         description: 'Web fuzzer (Go)',                      current: '-', latest: '-', status: 'unknown', size: '~5MB',   command: 'update_ffuf' },
        { id: 'subfinder',   name: 'Subfinder',    description: 'Subdomain discovery',          current: '-', latest: '-', status: 'unknown', size: '~15MB',  command: 'update_subfinder' },
        { id: 'amass',       name: 'Amass',        description: 'OSINT - surfaces d\'attaque',          current: '-', latest: '-', status: 'unknown', size: '~50MB',  command: 'update_amass' },
        { id: 'nuclei',      name: 'Nuclei',       description: 'Vulnerability scanner (templates)',   current: '-', latest: '-', status: 'unknown', size: '~20MB',  command: 'docker_pull_nuclei' },
        { id: 'impacket',    name: 'Impacket',     description: 'Python network protocols',             current: '-', latest: '-', status: 'unknown', size: '~20MB',  command: 'update_impacket' },
        { id: 'hashcat',     name: 'Hashcat',      description: 'Cracker de hash GPU/CPU',             current: '-', latest: '-', status: 'unknown', size: '~30MB',  command: 'update_hashcat' },
        { id: 'john',        name: 'John the Ripper', description: 'Cracker de mots de passe',         current: '-', latest: '-', status: 'unknown', size: '~10MB',  command: 'update_john' },
      ]
    },
    ad_tools: {
      title: "Outils Active Directory",
      icon: <Users className="w-5 h-5 text-orange-400" />,
      items: [
        { id: 'bloodhound',      name: 'BloodHound Python',  description: 'AD enumeration - graph collection',         current: '-', latest: '-', status: 'unknown', size: '~10MB',  command: 'update_bloodhound' },
        { id: 'netexec',         name: 'NetExec (CME)',       description: 'Post-exploitation SMB/LDAP/RDP (ex-CrackMapExec)', current: '-', latest: '-', status: 'unknown', size: '~50MB', command: 'update_netexec' },
        { id: 'enum4linux',      name: 'Enum4Linux',          description: 'SMB/Samba Windows/AD enumeration',             current: '-', latest: '-', status: 'unknown', size: '~5MB',   command: 'update_enum4linux' },
        { id: 'evil_winrm',      name: 'Evil-WinRM',          description: 'Shell WinRM pour post-exploitation',           current: '-', latest: '-', status: 'unknown', size: '~10MB',  command: 'update_evil_winrm' },
        { id: 'ldapdomaindump',  name: 'LDAP DomainDump',     description: 'Dump LDAP Active Directory',                   current: '-', latest: '-', status: 'unknown', size: '~5MB',   command: 'update_ldapdomaindump' },
      ]
    },
    dictionaries: {
      title: "Dictionnaires & Wordlists",
      icon: <FileText className="w-5 h-5 text-green-400" />,
      items: [
        { id: 'rockyou',     name: 'RockYou',               description: 'Wordlist mots de passe (14M entries)',   current: '-', latest: '-', status: 'unknown', size: '~140MB', command: 'update_rockyou' },
        { id: 'seclists',    name: 'SecLists',              description: 'Collection wordlists fuzzing et tests',  current: '-', latest: '-', status: 'unknown', size: '~1.2GB', command: 'update_seclists' },
        { id: 'defaultcreds',name: 'Default Credentials',  description: 'Default credentials database',             current: '-', latest: '-', status: 'unknown', size: '~50MB',  command: 'update_defaultcreds' },
        { id: 'nuclei_templates', name: 'Nuclei Templates', description: 'Vulnerability detection templates', current: '-', latest: '-', status: 'unknown', size: '~200MB', command: 'update_nuclei_templates' },
        { id: 'payloads',    name: 'PayloadsAllTheThings',  description: 'Payloads injections et exploits',        current: '-', latest: '-', status: 'unknown', size: '~100MB', command: 'update_payloads' },
        { id: 'ad_wordlists',name: 'Wordlists AD',          description: 'Active Directory specialized wordlists', current: '-', latest: '-', status: 'unknown', size: '~20MB',  command: 'update_ad_wordlists' },
      ]
    }
  });

  // Load from Redis cache on mount (instant)
  useEffect(() => {
    checkAllUpdates(false);
  }, []);

  const checkAllUpdates = async (refresh = false) => {
    setCheckingUpdates(true);
    try {
      const token = localStorage.getItem('access_token');
      const url = `/api/v1/system/updates/status${refresh ? '?refresh=true' : ''}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        timeout: refresh ? 70000 : 10000
      });

      if (response.data) {
        updateItemsFromResponse(response.data);
      }

      setLastCheck(new Date());
    } catch (error) {
      console.error('Failed to check updates:', error);
      setLastCheck(new Date());
    } finally {
      setCheckingUpdates(false);
    }
  };

  const updateItemsFromResponse = (data) => {
    const components = data.components || data;

    setUpdates(prev => {
      const newUpdates = { ...prev };

      Object.keys(newUpdates).forEach(category => {
        newUpdates[category] = {
          ...newUpdates[category],
          items: newUpdates[category].items.map(item => {
            const serverData = components[item.id];

            if (serverData) {
              let status = 'unknown';
              if (serverData.available) {
                status = serverData.last_update ? 'up-to-date' : 'up-to-date';
              } else {
                status = 'unavailable';
              }

              return {
                ...item,
                current: serverData.version || (serverData.available ? 'Installed' : 'Not installed'),
                latest: serverData.version || '-',
                status,
                available: serverData.available,
                lastUpdate: serverData.last_update,
                description: serverData.description || item.description
              };
            }
            return item;
          })
        };
      });

      return newUpdates;
    });
  };

  const handleUpdate = async (category, itemId, command) => {
    const key = `${category}_${itemId}`;
    setUpdating(prev => ({ ...prev, [key]: true }));
    setUpdateStatus(prev => ({ ...prev, [key]: 'updating' }));
    setUpdateOutput(prev => ({ ...prev, [key]: null }));

    try {
      const token = localStorage.getItem('access_token');
      const response = await axios.post(
        '/api/v1/system/updates/run',
        { command },
        {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 660000  // 11 minutes
        }
      );

      const output = response.data.output || response.data.message || '';
      setUpdateOutput(prev => ({ ...prev, [key]: output }));

      if (response.data.success) {
        // Distinguish 'already up to date' vs 'updated'
        const status = response.data.already_up_to_date ? 'already-up-to-date' : 'success';
        setUpdateStatus(prev => ({ ...prev, [key]: status }));

        setUpdates(prev => {
          const newUpdates = { ...prev };
          newUpdates[category] = {
            ...newUpdates[category],
            items: newUpdates[category].items.map(item => {
              if (item.id === itemId) {
                return {
                  ...item,
                  status: 'up-to-date',
                  available: true,
                  lastUpdate: new Date().toISOString()
                };
              }
              return item;
            })
          };
          return newUpdates;
        });
      } else {
        setUpdateStatus(prev => ({ ...prev, [key]: 'error' }));
        setUpdateOutput(prev => ({ ...prev, [key]: response.data.error || response.data.output || 'Erreur inconnue' }));
      }
    } catch (error) {
      console.error(`Update failed for ${itemId}:`, error);
      setUpdateStatus(prev => ({ ...prev, [key]: 'error' }));
      setUpdateOutput(prev => ({ ...prev, [key]: error.message || 'Network error' }));
    } finally {
      setUpdating(prev => ({ ...prev, [key]: false }));
      setTimeout(() => {
        setUpdateStatus(prev => ({ ...prev, [key]: null }));
      }, 8000);
    }
  };

  const handleUpdateAll = async (category) => {
    const items = updates[category].items;
    const total = items.length;

    setBulkUpdating(prev => ({ ...prev, [category]: true }));
    setBulkProgress(prev => ({ ...prev, [category]: { current: 0, total, item: '' } }));

    let successCount = 0;
    let alreadyCount = 0;
    let errorCount = 0;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      setBulkProgress(prev => ({
        ...prev,
        [category]: { current: i + 1, total, item: item.name }
      }));

      try {
        await handleUpdate(category, item.id, item.command);
        const key = `${category}_${item.id}`;
        // Check if already up to date
        successCount++;
      } catch (error) {
        errorCount++;
      }
    }

    setBulkUpdating(prev => ({ ...prev, [category]: false }));
    setBulkProgress(prev => ({
      ...prev,
      [category]: {
        current: total, total,
        item: `Completed: ${successCount} OK, ${errorCount} errors`,
        done: true
      }
    }));

    setTimeout(() => {
      setBulkProgress(prev => ({ ...prev, [category]: null }));
    }, 8000);
  };

  const getStatusBadge = (status, itemKey, available) => {
    const updateSt = updateStatus[itemKey];

    if (updateSt === 'success') {
      return (
        <span className="px-2 py-1 bg-green-500/30 text-green-300 text-xs rounded flex items-center gap-1 animate-pulse">
          <CheckCircle className="w-3 h-3" />
          Updated!
        </span>
      );
    }

    if (updateSt === 'already-up-to-date') {
      return (
        <span className="px-2 py-1 bg-blue-500/30 text-blue-300 text-xs rounded flex items-center gap-1">
          <CheckCircle className="w-3 h-3" />
          Already up to date
        </span>
      );
    }

    if (updateSt === 'error') {
      return (
        <span className="px-2 py-1 bg-red-500/30 text-red-400 text-xs rounded flex items-center gap-1">
          <AlertCircle className="w-3 h-3" />
          Erreur
        </span>
      );
    }

    if (updateSt === 'updating') {
      return (
        <span className="px-2 py-1 bg-yellow-500/20 text-yellow-400 text-xs rounded flex items-center gap-1 animate-pulse">
          <RefreshCw className="w-3 h-3 animate-spin" />
          Updating...
        </span>
      );
    }

    if (status === 'unavailable' || available === false) {
      return (
        <span className="px-2 py-1 bg-red-500/20 text-red-400 text-xs rounded flex items-center gap-1">
          <AlertCircle className="w-3 h-3" />
          Not installed
        </span>
      );
    }

    if (status === 'up-to-date') {
      return (
        <span className="px-2 py-1 bg-green-500/20 text-green-400 text-xs rounded flex items-center gap-1">
          <CheckCircle className="w-3 h-3" />
          Installed
        </span>
      );
    }

    if (status === 'update-available') {
      return (
        <span className="px-2 py-1 bg-yellow-500/20 text-yellow-400 text-xs rounded flex items-center gap-1">
          <AlertCircle className="w-3 h-3" />
          MAJ disponible
        </span>
      );
    }

    return (
      <span className="px-2 py-1 bg-gray-500/20 text-gray-400 text-xs rounded flex items-center gap-1">
        <Clock className="w-3 h-3" />
        Not checked
      </span>
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between bg-brand-black rounded-lg p-4 border border-gray-800">
        <div>
          <h3 className="font-bold text-white flex items-center gap-2">
            <Database className="w-5 h-5 text-brand-green" />
            Update manager
          </h3>
          <p className="text-xs text-gray-400 mt-1">
            Last check: {lastCheck ? formatDate(lastCheck) : 'Never'}
          </p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={() => handleUpdateAll('vulnerabilities')}
            disabled={bulkUpdating['vulnerabilities']}
            className="px-4 py-2 bg-red-500/20 text-red-400 border border-red-500/50 rounded-lg hover:bg-red-500/30 transition-colors text-sm font-medium flex items-center gap-2 disabled:opacity-50"
          >
            <Shield className="w-4 h-4" />
            MAJ Bases CVE
          </button>
          <button
            onClick={() => checkAllUpdates(true)}
            disabled={checkingUpdates}
            className="px-4 py-2 bg-brand-green text-brand-black rounded-lg hover:bg-green-600 transition-colors text-sm font-medium flex items-center gap-2 disabled:opacity-50"
          >
            {checkingUpdates ? (
              <><RefreshCw className="w-4 h-4 animate-spin" />Checking...</>
            ) : (
              <><RefreshCw className="w-4 h-4" />Check for updates</>
            )}
          </button>
        </div>
      </div>

      {/* Sections */}
      {Object.entries(updates).map(([category, section]) => (
        <div key={category} className="bg-brand-black rounded-lg p-5 border border-gray-800">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-bold text-white flex items-center gap-2">
              {section.icon}
              {section.title}
              <span className="text-xs text-gray-500 font-normal">
                ({section.items.filter(i => i.available !== false).length}/{section.items.length} disponibles)
              </span>
            </h3>
            <div className="flex items-center gap-3">
              {bulkProgress[category] && (
                <div className="flex flex-col gap-1 min-w-[160px]">
                  {bulkProgress[category].done ? (
                    <span className="text-green-400 text-xs flex items-center gap-1">
                      <CheckCircle className="w-3 h-3" />
                      {bulkProgress[category].item}
                    </span>
                  ) : (
                    <>
                      <div className="flex items-center gap-2 text-xs text-gray-400">
                        <RefreshCw className="w-3 h-3 animate-spin text-brand-green flex-shrink-0" />
                        <span className="text-brand-green font-medium">{bulkProgress[category].current}/{bulkProgress[category].total}</span>
                        <span className="text-gray-500 truncate max-w-[100px]">{bulkProgress[category].item}</span>
                      </div>
                      {/* Determinate progress bar */}
                      <div className="w-full bg-gray-800 rounded-full h-1.5 overflow-hidden">
                        <div
                          className="h-full rounded-full bg-brand-green transition-all duration-500 ease-out"
                          style={{ width: `${Math.round((bulkProgress[category].current / bulkProgress[category].total) * 100)}%` }}
                        />
                      </div>
                    </>
                  )}
                </div>
              )}
              <button
                onClick={() => handleUpdateAll(category)}
                disabled={bulkUpdating[category]}
                className={`px-4 py-2 rounded-lg transition-colors text-sm font-medium flex items-center gap-2 ${
                  bulkUpdating[category]
                    ? 'bg-brand-green/50 text-brand-black cursor-wait'
                    : 'bg-brand-green text-brand-black hover:bg-green-600'
                }`}
              >
                {bulkUpdating[category] ? (
                  <><RefreshCw className="w-4 h-4 animate-spin" />En cours...</>
                ) : (
                  <><Download className="w-4 h-4" />Update All</>
                )}
              </button>
            </div>
          </div>

          <div className="space-y-2">
            {section.items.map((item) => {
              const key = `${category}_${item.id}`;
              const isUpdating = updating[key];

              return (
                <div key={item.id} className="p-3 bg-brand-black-lighter rounded hover:bg-brand-black transition-colors">
                  <div className="flex items-center justify-between">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-3 mb-1">
                        <div className="font-medium text-white text-sm">{item.name}</div>
                        {getStatusBadge(item.status, key, item.available)}
                      </div>
                      <div className="flex items-center gap-4 text-xs text-gray-500 flex-wrap">
                        {item.description && <span>{item.description}</span>}
                        {item.current && item.current !== '-' && (
                          <span className="text-gray-400">v: {item.current.length > 40 ? item.current.slice(0, 40) + '...' : item.current}</span>
                        )}
                        <span>{item.size}</span>
                        {item.lastUpdate && (
                          <span>MAJ: {formatDate(item.lastUpdate)}</span>
                        )}
                      </div>
                    </div>

                    <button
                      onClick={() => handleUpdate(category, item.id, item.command)}
                      disabled={isUpdating}
                      className={`ml-3 px-3 py-1.5 rounded-lg transition-colors text-xs flex items-center gap-1.5 disabled:opacity-50 whitespace-nowrap ${
                        item.status === 'update-available'
                          ? 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/50 hover:bg-yellow-500/30'
                          : item.available === false
                          ? 'bg-red-500/20 text-red-400 border border-red-500/50 hover:bg-red-500/30'
                          : 'bg-blue-500/20 text-blue-400 border border-blue-500/50 hover:bg-blue-500/30'
                      }`}
                    >
                      {isUpdating ? (
                        <><RefreshCw className="w-3 h-3 animate-spin" />{item.available === false ? 'Installing...' : 'Updating...'}</>
                      ) : (
                        <><Download className="w-3 h-3" />{item.status === 'update-available' ? 'Update' : item.available === false ? 'Install' : 'Update / Check'}</>
                      )}
                    </button>
                  </div>

                  {/* Output */}
                  {(isUpdating || updateOutput[key]) && (
                    <div className="mt-2 pt-2 border-t border-gray-700">
                      {isUpdating && (
                        <div className="mb-2">
                          <div className="flex items-center gap-2 text-xs text-gray-400 mb-1.5">
                            <RefreshCw className="w-3 h-3 animate-spin text-brand-green" />
                            <span className="text-brand-green font-medium">
                              {item.available === false ? 'Installing...' : 'Updating...'}
                            </span>
                          </div>
                          {/* Scrolling indeterminate progress bar */}
                          <div className="w-full bg-gray-800 rounded-full h-1.5 overflow-hidden">
                            <div className="h-full w-1/3 rounded-full bg-brand-green animate-indeterminate origin-left" />
                          </div>
                        </div>
                      )}
                      {updateOutput[key] && (
                        <div className={`text-xs font-mono p-2 rounded max-h-48 overflow-y-auto ${
                          updateStatus[key] === 'error'
                            ? 'bg-red-500/10 text-red-400'
                            : updateStatus[key] === 'already-up-to-date'
                            ? 'bg-blue-500/10 text-blue-300'
                            : 'bg-green-500/10 text-green-400'
                        }`}>
                          <pre className="whitespace-pre-wrap break-all">{updateOutput[key].slice(-2000)}</pre>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {/* Info */}
      <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <div className="text-blue-500 mt-0.5">&#9432;</div>
          <div className="text-sm text-gray-300">
            <div className="font-medium text-blue-400 mb-2">Informations</div>
            <ul className="space-y-1 text-xs text-gray-400">
              <li><strong className="text-red-400">CVE/NVD & CISA KEV</strong>: Daily update recommended</li>
              <li><strong className="text-orange-400">Metasploit</strong>: Update via git pull in the container</li>
              <li><strong className="text-purple-400">LLM Models</strong>: Pull via internal Ollama API (may take several minutes)</li>
              <li><strong className="text-yellow-400">Conteneurs Docker</strong> : Image pull via Docker socket (sans docker CLI)</li>
              <li><strong className="text-green-400">CLI Tools</strong>: Version check + update if available</li>
              <li><strong className="text-orange-400">Outils AD</strong> : NetExec, BloodHound, Evil-WinRM pour pentest Active Directory</li>
            </ul>
            <div className="mt-3 p-2 bg-blue-500/10 rounded border border-blue-500/30">
              <p className="text-blue-300 text-xs">
                <strong>Blue badge "Already up to date"</strong>: The tool is installed and current, no action required.
                <strong className="ml-2">Green badge "Updated!"</strong>: The update was successfully applied.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatesManager;
